import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetReportPermissionsQuery = (shareToken: string) => {
  const { prototypesShare } = useAvApi();

  const data = useQuery({
    enabled: !!shareToken,
    queryKey: ['report-permissions', shareToken],
    queryFn: async () => {
      if (!shareToken) return;
      const data =
        await prototypesShare.getV2PrototypesShareSubscriptionInfoByShareToken({
          shareToken,
        });

      return data.data;
    },
  });

  return data;
};
